<router-outlet></router-outlet>

<!-- <app-updates-popup [isOpen]="isUpdatesAvailable"></app-updates-popup> -->
